export enum StoreWebhookEventType {
    ORDER_CREATED = 1,
}